// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__5ABBL","modal":"styles_modal__drvmG"};